import "../../../assets/css/whatsnext.css";
import { Say } from "../../../languages";
import Video from "../Video/Video";

export function WhatsNext() {
  return (
    <div className="WhatsNext whats-next">
      <div className="whats-next__video-container">
        <Video
          className="whats-next__video"
          url="https://wvusstatic.com/chosen/whats-next-vignette-yinka-mary-long.mp4"
          poster="https://wvusstatic.com/chosen/whats-next-vignette-yinka-mary-long-thumbnail.jpg"
          playIcon="https://wvusstatic.com/chosen/white-play-icon.svg"
        />
      </div>
      <div className="whats-next__content">
        <h3 className="whats-next__header">
          <Say phrase="chosen.thank_you.expect_next_heading" />
        </h3>
        <p className="whats-next__text">
          <Say phrase="chosen.thank_you.expect_next_message" />
        </p>
      </div>
    </div>
  );
}

export default WhatsNext;
